import * as React from "react";

import {PhosphorIcon} from "@khanacademy/wonder-blocks-icon";
import {faceIconColor} from "@khan/auth-shared";

import EnvelopeSimpleIcon from "@phosphor-icons/core/regular/envelope-simple.svg";

const EnvelopeIcon = ({
    disabled = false,
    ariaHidden,
    size,
}: {
    disabled?: boolean;
    ariaHidden?: boolean;
    size?: "small" | "medium" | "large";
}): React.ReactElement<React.ComponentProps<"svg">> => {
    const fadeFn = faceIconColor(disabled);
    return (
        <PhosphorIcon
            color={fadeFn("#000000")}
            aria-hidden={ariaHidden}
            icon={EnvelopeSimpleIcon}
            size={size}
        />
    );
};

export default EnvelopeIcon;
